import { COUNTRY_CODES_MAP } from "../../../Utils/countryCodes"
import { getDates } from "../../../Utils/utils"

// The [from, to] pair a calendar preset resolves to. null where the preset has no bounds
// ("All time"), which every caller treats as no narrowing.
export const rangeOfPeriod = (period) => {
  const d = getDates(period)
  return d?.start_date && d?.end_date ? [d.start_date, d.end_date] : null
}

// Short names where the ISO one is a mouthful ("United States of America"), then the ISO name,
// then the raw code.
const SHORT_NAMES = {
  US: "United States",
  GB: "United Kingdom",
  KR: "South Korea",
  RU: "Russia",
  VN: "Vietnam",
  TW: "Taiwan"
}

export const countryName = (code) =>
  code ? SHORT_NAMES[code] || COUNTRY_CODES_MAP[code] || code : ""
